import { apiClient } from "@/lib/api-client";

import type {
  WaitlistListResponse,
  WaitlistMutationResponse,
  WaitlistSignup,
  WaitlistStats,
  WaitlistStatsResponse,
} from "./types";

export async function fetchWaitlistSignups(): Promise<WaitlistSignup[]> {
  const response = await apiClient.get<WaitlistListResponse>("/waitlist");
  return response.data;
}

export async function fetchWaitlistStats(): Promise<WaitlistStats> {
  const response = await apiClient.get<WaitlistStatsResponse>("/waitlist/stats");
  return response.data;
}

export async function addWaitlistEmail(
  email: string
): Promise<{ success: boolean; alreadyExists: boolean }> {
  const response = await apiClient.post<WaitlistMutationResponse>("/waitlist", {
    email,
    source: "manual_admin",
  });
  return {
    success: true,
    alreadyExists: response.status === "already_exists",
  };
}

export async function deleteWaitlistSignup(id: string): Promise<void> {
  await apiClient.del<WaitlistMutationResponse>(`/waitlist/${id}`);
}
